import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TestAuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0] || "";
    axios.post(`${API}/test/auth/google`, { session_id: sessionId })
      .then(({ data }) => {
        localStorage.setItem("pjp-student", data.student_id);
        localStorage.setItem("pjp-student-name", data.name || "");
        if (data.needs_details) {
          navigate("/physics-test", { state: { quickComplete: data }, replace: true });
        } else {
          navigate("/physics-test/topics", { replace: true });
        }
      })
      .catch(() => navigate("/physics-test", { state: { quickError: "Google sign-in failed. Please try again or use the form." }, replace: true }));
  }, [location, navigate]);
  return null;
}
